import { createContext } from "react";
import { OpensearchCuratedSearch } from "../__generated__/graphql";

interface IAutopilotCuratedInternalSearchContext {
  onSaveFilters: (value: {
    currentFilters: OpensearchCuratedSearch;
    scoringCriteriaValues: string[];
  }) => Promise<void>;
  savedFilters: OpensearchCuratedSearch | null;
  setSavedFilters: (filters: OpensearchCuratedSearch) => void;
}

const AutopilotCuratedInternalSearchContext =
  createContext<IAutopilotCuratedInternalSearchContext>({
    onSaveFilters: ({
      currentFilters,
      scoringCriteriaValues,
    }: {
      currentFilters: OpensearchCuratedSearch;
      scoringCriteriaValues: string[];
    }) => {
      return Promise.resolve();
    },
    savedFilters: null,
    setSavedFilters: () => {
      return;
    },
  });

export default AutopilotCuratedInternalSearchContext;
